module.exports = __webpack_public_path__ + "static/emblem-cd70986a1724abf5ddca53c7f7ccbc84.png";